<template>
  <div class="orderprocessdoublerole-list">
    <v-card >

      <v-app-bar flat v-bind:class="classSupervision('text-xl-h5')" >
        <v-icon>mdi-basket</v-icon>

        <v-badge style="badge-border-radius: '50px'" :content="totalOrders" :value="totalOrders" inline>
          <v-toolbar-title class="title pl-1" v-bind:class="classSupervision('text-xl-h5')">
            <router-link class="routerLink" :to="{ name: 'OrderListDoubleRole', params: { }  }">{{$t('order.myorders')}}</router-link>
          </v-toolbar-title>
        </v-badge>
        <v-spacer></v-spacer>
        <v-btn
            class="ml-sm-2"
            color="primary"
            @click="orderaction"
        >
          {{ $t('order.orderaction')}}
        </v-btn>
      </v-app-bar>

        <template>
        <v-app-bar>
          <tr>
            <v-combobox
              v-model="selectedState"
              :items="orderstateSelectItems"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('order.state')"
              item-text="name"
              item-value="@id"
              @change="filteredOrdersStatus"
            />
          </tr>
            <v-menu icon  open-on-hover transition="slide-x-transition" >
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-auto" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
              </template>
              <v-card max-width="300" min-width = "150" tile style="padding: 10px;">
                <v-list >
                    <v-switch
                  :label="typeFilter ? $t('order.toDo') : $t('order.general')"
                  v-model= typeFilter
                  @change="filteredOrders"
                ></v-switch>
                <v-switch
                  :label="roleFilter ? $t('order.operator') : $t('order.claimant')"
                  v-model= roleFilter
                  @change="filteredOrders"
                ></v-switch>
                </v-list>
              </v-card>
            </v-menu>
      </v-app-bar>
</template>
      
      <v-card-text class = "order">
        <div v-if="!role" class="font-weight-bold ml-4 mb-2" v-bind:class="classSupervision('text-xl-h6')">
          {{$t('global.timeline')}}
        </div>
        <div v-else class="font-weight-bold ml-4 mb-2" v-bind:class="classSupervision('text-xl-h6')">
          {{$t('priority.priority')}}
        </div>
        <v-simple-table align-center dense class="decalage">
          <tr class="home"
              v-for="order in orders"
              :key="order.id"
          >
            <td>

            <v-simple-table>
              <tr>
                <td width="10"></td>
                <td width="150">
                  <!-- imgage -->
                  <v-img
                      class="rounded-xl"
                      height="100"
                      width="100"
                      v-if="order.designFile"
                      @click="showHandler(order)"
                      @contextmenu = "showHandlerExt($event,order)"
                      lazy-src="@/assets/3dfile.png"
                      :key="componentKey"
                      :src="getImageUrlByObject(order.designFile)"
                  />
                </td>
                <td>
                  <button class="text-left" v-bind:class="classSupervision('text-xl-h6')" @click="showHandler(order)" @contextmenu = "showHandlerExt($event,order)">
                    <div>
                      <!-- Id + Ref + Quantite -->
                      <strong class="text-h6">{{ order.id }} - {{order.ref}} -- x{{order.quantity}}</strong><br/>
                      <!-- Client -->
                      {{$t('customer.customer')}} : {{ order.customer.name }}<br/>
                      <!-- Etat d'ordre (en couleur) + type d'ordre -->
                    <span :style="{ color:order.state.couleur  }">{{ order.state.name }}</span> - {{ order.type.name }} <br/>
                      <!-- date de livraison previsionnel en internne -->
                    {{$t('order.delivery_short_interne')}} : <span v-if="order.delivery"> {{ formatDate(order.delivery, 'long') }}</span><span v-else>{{$t('order.no_delivery')}}</span><br/>
                      <!-- date de livraison desire par le client -->
                    {{$t('order.delivery_short')}} : <span v-if="order.deliveryObjectif"> {{ formatDate(order.deliveryObjectif, 'long') }}</span><span v-else>{{$t('order.no_delivery')}}</span><br/>
                    </div>
                  </button>
                </td>
              </tr>
            </v-simple-table>
            </td>
<!--          </v-timeline-item>-->
          </tr>

        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions,mapState, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import FileMixin from "@/mixins/FileMixin";

export default {
  name: 'OrderListDoubleRole',
  servicePrefix: 'Order',
  mixins: [ListMixin, FileMixin],
  props: {
    supervision: {
      type: Boolean,
      required: false,
      default: () => false
    },
    role: {
      type: Boolean, //1 for labo, 0 for comm
      required: true,
    }

  },
  components: {
  },
  data() {
    return {
      roleFilter: this.role, //1 for labo, 0 for comm
      typeFilter:true,
      selectedState: null,
      filter: '100x100',
      userProfil: null,
      orderDatas: null
    };
  },
  mounted() {
    
    this.orderstateGetSelectItems( { 'params': { 'order[name]'  : 'asc'} });
    this.userGetData({data: 'profil'});
    this.user = this.dataUser('profil');
    this.filteredOrders();
    if (this.supervision) this.pollData();
  },
  computed: {
    orders: {
        get() { return this.orderDatas },
          set(value) { this.orderDatas = value; }
      },
    user: {
      get() { return this.userProfil },
      set(value) { this.userProfil = value; }
    },
    ...mapFields('orderstate', {
      orderstateSelectItems: 'selectItems',
    }),
    ...mapGetters('user',{
      dataUser: 'data',
    }),
    ...mapState('order', {
      updatedata: 'updatedata',
    }),
    ...mapGetters('order',{
      dataOrder: 'data',
    }),
    ...mapFields('order', {
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    totalOrders() {
      if (this.orders) return this.orders.length;
      return 0;
    },
    ...mapGetters('designfile', {
      designfiles: 'list'
    }),
    ...mapFields('designfile', {
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    showHandlerExt(event, item) {
      let routeData = this.$router.resolve({
        name: `${this.$options.servicePrefix}Show`,
        params: { id: item['@id'] }
      });
      window.open(routeData.href, '_blank');
      event.preventDefault()
    },
    ...mapActions({
      orderstateGetSelectItems: 'orderstate/fetchSelectItems',
    }),
    ...mapActions({
      userGetData: 'user/data'
    }),
    ...mapActions('designfile', {
      getDesignFiles: 'fetchAll'
    }),
    ...mapActions({
      orderGetSelectItems: 'order/fetchAllData'
    }),
    classSupervision(classText) {
      if (this.supervision) return classText;
      return '';
    },

    colorOrderBackground() {
      return "background-color: " + this.order.state.couleur
    },

    filteredOrders() {
      if (this.selectedState === null){
        if (this.roleFilter) {
          if(this.typeFilter){
            this.orderGetSelectItems( { 'params': {'state.labo':1,'operator.login': this.userProfil.login, 'order[priority.intensity]'  : 'desc','order[deliveryObjectif]'  : 'asc','order[delivery]' : 'asc', 'itemsPerPage': '200'} ,'data': ('myorders') });
          } 
          else{
            this.orderGetSelectItems( { 'params': { 'state.end':0 ,'operator.login': this.userProfil.login, 'order[priority.intensity]'  : 'desc','order[deliveryObjectif]'  : 'asc','order[delivery]' : 'asc', 'itemsPerPage': '200'} ,'data': ('myorders') });
          }
        }
        else {
          if(this.typeFilter){
            this.orderGetSelectItems( { 'params': {'state.commerciaux':1,'commercial.login': this.userProfil.login, 'order[priority.intensity]'  : 'desc','order[deliveryObjectif]'  : 'asc','order[delivery]' : 'asc', 'itemsPerPage': '200'} ,'data': ('myorders') });
          }
          else{
            this.orderGetSelectItems( { 'params': { 'state.end':0 ,'commercial.login': this.userProfil.login, 'order[priority.intensity]'  : 'desc','order[deliveryObjectif]'  : 'asc','order[delivery]' : 'asc', 'itemsPerPage': '200'} ,'data': ('myorders') });
          }
        }
      }
      else{
        if (this.roleFilter) {
          this.orderGetSelectItems( { 'params': { 'state':this.selectedState.id ,'operator.login': this.userProfil.login, 'order[priority.intensity]'  : 'desc','order[deliveryObjectif]'  : 'asc','order[delivery]' : 'asc', 'itemsPerPage': '200'} ,'data': ('myorders') });
        } 
        else {
          this.orderGetSelectItems( { 'params': { 'state':this.selectedState.id,'commercial.login': this.userProfil.login, 'order[priority.intensity]'  : 'desc','order[deliveryObjectif]'  : 'asc','order[delivery]' : 'asc', 'itemsPerPage': '200'} ,'data': ('myorders') });
        }
      }
    },

    filteredOrdersStatus() {
      this.orders.filter(order => order.state === this.selectedState);
      return this.filteredOrders()
    },

    pollData () {

      // Si la page n'est pas actif, on ne recherche pas de nouvelles commandes
      if (!document.hidden) {

        this.polling = setInterval(() => {
          if (!document.hidden) {
            this.filteredOrders()
          }
        }, 100000);
      }
    },

    orderaction() {
      this.$router.push({ name: `OrderCreate` });
    },
  },
  watch: {
    updatedata: function (updatedata) {
      if (updatedata == 'myorders') {
        this.orders = this.dataOrder('myorders');
      }
    },
  }
};
</script>
<style>
tr.home {
  height: 140px;
}
.decalage {
  padding-left: 2%;
}
.menu-padding {
    padding: 16px;
  }
</style>
